import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ac1dd06")

_pushScopeId("data-v-7ac1dd06")
const _hoisted_1 = { class: "kn-page-content p-m-0" }
const _hoisted_2 = { class: "p-d-flex p-flex-row" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-field p-d-flex p-ai-center" }
const _hoisted_5 = {
  class: "p-d-flex p-flex-column p-mr-2",
  id: "glossary-select-container"
}
const _hoisted_6 = {
  for: "glossary",
  class: "kn-material-input-label"
}
const _hoisted_7 = { id: "glossary-help" }
const _hoisted_8 = {
  key: 0,
  id: "code-container"
}
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "code",
  class: "kn-material-input-label"
}
const _hoisted_11 = {
  key: 0,
  class: "p-field p-d-flex kn-flex"
}
const _hoisted_12 = { class: "p-float-label kn-flex" }
const _hoisted_13 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-d-flex p-flex-row p-m-3" }
const _hoisted_16 = { class: "node-label p-mr-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Message = _resolveComponent("Message")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Tree = _resolveComponent("Tree")
  const _component_Card = _resolveComponent("Card")
  const _component_GlossaryDefinitionHint = _resolveComponent("GlossaryDefinitionHint")
  const _component_GlossaryDefinitionNodeDialog = _resolveComponent("GlossaryDefinitionNodeDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.title')), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_FabButton, {
          icon: "fas fa-plus",
          class: "fab-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewGlossary('Save')))
        })
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, { class: "p-m-3" }, {
      header: _withId(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.glossary')), 1)
          ]),
          end: _withId(() => [
            _createVNode("div", _hoisted_2, [
              (_ctx.selectedGlossary && _ctx.selectedGlossaryId && _ctx.selectedGlossaryId != -1)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                      class: "kn-button p-button-text glossary-info-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewGlossary('Clone')))
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.clone')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      class: "kn-button p-button-text glossary-info-button",
                      onClick: _ctx.deleteGlossaryConfirm
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      content: _withId(() => [
        _createVNode(_component_Message, { class: "p-mt-0" }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.help')), 1)
          ]),
          _: 1
        }),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.title')), 1),
              _createVNode(_component_Dropdown, {
                id: "glossary",
                class: "kn-material-input",
                modelValue: _ctx.selectedGlossaryId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedGlossaryId = $event)),
                options: _ctx.glossaries,
                optionLabel: "GLOSSARY_NM",
                optionValue: "GLOSSARY_ID",
                editable: _ctx.selectedGlossary,
                placeholder: _ctx.$t('managers.glossary.glossaryDefinition.glossary'),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadGlossaryInfo($event.value, null))),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateGlossaryName($event.target.value))),
                onBlur: _ctx.handleSaveGlossary
              }, null, 8, ["modelValue", "options", "editable", "placeholder", "onBlur"]),
              _createVNode("small", _hoisted_7, _toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.glossaryHint')), 1)
            ]),
            (_ctx.selectedGlossary)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, [
                    _createVNode(_component_InputText, {
                      id: "code",
                      class: "kn-material-input full-width",
                      modelValue: _ctx.selectedGlossary.GLOSSARY_CD,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedGlossary.GLOSSARY_CD = $event)),
                      modelModifiers: { trim: true },
                      onBlur: _ctx.handleSaveGlossary
                    }, null, 8, ["modelValue", "onBlur"]),
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.glossary.common.code')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.selectedGlossary)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_InputText, {
                    id: "description",
                    class: "kn-material-input full-width",
                    modelValue: _ctx.selectedGlossary.GLOSSARY_DS,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedGlossary.GLOSSARY_DS = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _ctx.handleSaveGlossary
                  }, null, 8, ["modelValue", "onBlur"]),
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.description')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.selectedGlossary && _ctx.showTree)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
                start: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tc('managers.glossary.common.word', 2)), 1)
                ]),
                end: _withId(() => [
                  (_ctx.selectedGlossary && _ctx.selectedGlossaryId && _ctx.selectedGlossaryId != -1)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "kn-button p-button-text",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showNodeDialog(null, 'new')))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.addNode')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_InputText, {
                  id: "search-input",
                  class: "kn-material-input",
                  modelValue: _ctx.searchWord,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchWord = $event)),
                  placeholder: _ctx.$t('common.search'),
                  onInput: _ctx.filterGlossaryTree,
                  "data-test": "search-input"
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _createVNode(_component_Tree, {
                id: "glossary-tree",
                value: _ctx.nodes,
                expandedKeys: _ctx.expandedKeys,
                onNodeExpand: _cache[11] || (_cache[11] = ($event: any) => (_ctx.listContents(_ctx.selectedGlossary.GLOSSARY_ID, $event)))
              }, {
                default: _withId((slotProps) => [
                  _createVNode("div", {
                    class: ["p-d-flex p-flex-row p-ai-center", { dropzone: _ctx.dropzoneActive[slotProps.node.key] }],
                    onMouseover: ($event: any) => (_ctx.buttonVisible[slotProps.node.key] = true),
                    onMouseleave: ($event: any) => (_ctx.buttonVisible[slotProps.node.key] = false),
                    onDrop: ($event: any) => (_ctx.saveWordConfirm($event, slotProps.node)),
                    onDragover: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
                    onDragenter: _withModifiers(($event: any) => (_ctx.setDropzoneClass(true, slotProps.node)), ["prevent"]),
                    onDragleave: _withModifiers(($event: any) => (_ctx.setDropzoneClass(false, slotProps.node)), ["prevent"])
                  }, [
                    _createVNode("span", _hoisted_16, _toDisplayString(slotProps.node.label), 1),
                    _withDirectives(_createVNode("div", null, [
                      (!slotProps.node.data.HAVE_WORD_CHILD && slotProps.node.data.CONTENT_NM)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "pi pi-bars",
                            class: "p-button-link p-button-sm p-p-0",
                            onClick: _withModifiers(($event: any) => (_ctx.showNodeDialog(slotProps.node, 'new')), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('managers.glossary.glossaryDefinition.addNode'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (!slotProps.node.data.HAVE_CONTENTS_CHILD && slotProps.node.data.CONTENT_NM)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            icon: "pi pi-book",
                            class: "p-button-link p-button-sm p-p-0",
                            onClick: _withModifiers(($event: any) => (_ctx.addWord(slotProps.node)), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('managers.glossary.glossaryDefinition.addWord'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (slotProps.node.data.CONTENT_NM)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            icon: "pi pi-pencil",
                            class: "p-button-link p-button-sm p-p-0",
                            onClick: _withModifiers(($event: any) => (_ctx.showNodeDialog(slotProps.node, 'edit')), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('common.edit'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_Button, {
                        icon: "pi pi-info-circle",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('infoClicked', slotProps.node.data)), ["stop"])
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('managers.glossary.glossaryDefinition.showInfo'),
                          void 0,
                          { top: true }
                        ]
                      ]),
                      _withDirectives(_createVNode(_component_Button, {
                        icon: "far fa-trash-alt",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.deleteNodeConfirm(slotProps.node)), ["stop"])
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('common.delete'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    ], 512), [
                      [_vShow, _ctx.buttonVisible[slotProps.node.key]]
                    ])
                  ], 42, ["onMouseover", "onMouseleave", "onDrop", "onDragenter", "onDragleave"])
                ]),
                _: 1
              }, 8, ["value", "expandedKeys"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showHint)
      ? (_openBlock(), _createBlock(_component_GlossaryDefinitionHint, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_GlossaryDefinitionNodeDialog, {
      visible: _ctx.nodeDialogVisible,
      selectedContent: _ctx.selectedContent,
      onSave: _ctx.saveContent,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.nodeDialogVisible = false))
    }, null, 8, ["visible", "selectedContent", "onSave"])
  ]))
})